(() => {
  const roots = document.querySelectorAll('[data-sts-resource-assistant]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const form = root.querySelector('[data-assistant-form]');
    const input = root.querySelector('[data-assistant-input]');
    const messages = root.querySelector('[data-assistant-messages]');
    const reset = root.querySelector('[data-assistant-reset]');
    const prompts = root.querySelectorAll('[data-assistant-prompt]');
    const endpoint = String(root.dataset.endpoint || '').trim().replace(/\/+$/, '');
    const shopId = root.dataset.shopId || '';
    const phone = root.dataset.phone || '626-692-5233';
    const email = root.dataset.email || 'sales@stonetechsolutionsna.com';
    const sessionKey = 'stsResourceConversationId';

    if (!form || !input || !messages) return;

    const scrollToLatest = () => {
      messages.scrollTop = messages.scrollHeight;
    };

    const addMessage = (text, sender, status = false) => {
      const article = document.createElement('article');
      article.className = `sts-assistant__message sts-assistant__message--${sender}${status ? ' sts-assistant__message--status' : ''}`;

      if (sender === 'assistant') {
        const avatar = document.createElement('span');
        avatar.className = 'sts-assistant__avatar';
        avatar.setAttribute('aria-hidden', 'true');
        avatar.textContent = 'ST';
        article.appendChild(avatar);
      }

      const content = document.createElement('div');
      if (sender === 'assistant' && !status) {
        const name = document.createElement('strong');
        name.textContent = 'Stone Tech Assistant';
        content.appendChild(name);
      }
      const paragraph = document.createElement('p');
      paragraph.textContent = text;
      content.appendChild(paragraph);
      article.appendChild(content);
      messages.appendChild(article);
      scrollToLatest();
      return paragraph;
    };

    const supportFallback = () => `The live AI connection is not active yet. For a verified answer now, call ${phone} or email ${email}.`;

    const parseStream = async (response, output) => {
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let answer = '';

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const events = buffer.split('\n\n');
        buffer = events.pop() || '';

        events.forEach((event) => {
          event.split('\n').forEach((line) => {
            if (!line.startsWith('data: ')) return;
            try {
              const data = JSON.parse(line.slice(6));
              if (data.type === 'id' && data.conversation_id) sessionStorage.setItem(sessionKey, data.conversation_id);
              if (data.type === 'chunk' && data.chunk) {
                answer += data.chunk;
                output.textContent = answer;
                scrollToLatest();
              }
            } catch (error) {
              console.warn('Stone Tech assistant returned an unreadable event.', error);
            }
          });
        });
      }

      if (!answer) output.textContent = supportFallback();
    };

    const send = async (message) => {
      const cleanMessage = String(message || '').trim();
      if (!cleanMessage) return;

      addMessage(cleanMessage, 'user');
      input.value = '';

      if (!endpoint) {
        const status = addMessage('Checking the assistant connection...', 'assistant', true);
        window.setTimeout(() => { status.textContent = supportFallback(); }, 450);
        return;
      }

      const output = addMessage('Thinking...', 'assistant');
      try {
        const response = await fetch(`${endpoint}/chat`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/event-stream',
            'X-Shopify-Shop-Id': shopId
          },
          body: JSON.stringify({
            message: cleanMessage,
            conversation_id: sessionStorage.getItem(sessionKey),
            prompt_type: 'stoneTechAssistant'
          })
        });

        if (!response.ok || !response.body) throw new Error(`Assistant service returned ${response.status}`);
        output.textContent = '';
        await parseStream(response, output);
      } catch (error) {
        console.error('Stone Tech assistant request failed.', error);
        output.textContent = supportFallback();
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      send(input.value);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        form.requestSubmit();
      }
    });

    prompts.forEach((prompt) => {
      prompt.addEventListener('click', () => send(prompt.dataset.assistantPrompt));
    });

    reset?.addEventListener('click', () => {
      sessionStorage.removeItem(sessionKey);
      messages.querySelectorAll('.sts-assistant__message').forEach((message, index) => {
        if (index > 0) message.remove();
      });
      input.focus();
    });
  });
})();
